import { motion, useReducedMotion } from "framer-motion";
import { Section } from "./Section";
import { LucideIcon } from "@/components/marketing/LucideIcon";
import { SECURITY } from "@/content/landing";

export function SecurityCompliance() {
  const reduce = useReducedMotion();
  return (
    <Section
      id="security"
      testId="landing-security"
      eyebrow={SECURITY.eyebrow}
      title={SECURITY.title}
      subtitle={SECURITY.subtitle}
    >
      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {SECURITY.pillars.map((p, i) => (
          <motion.div
            key={p.title}
            data-testid={`security-pillar-${i}`}
            initial={reduce ? { opacity: 1, y: 0 } : { opacity: 0, y: 18 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.45, ease: "easeOut", delay: (i % 3) * 0.08 }}
            className="group flex gap-4 rounded-2xl border border-border/60 bg-card/50 p-6 backdrop-blur transition-colors hover:border-sema-accent/40"
          >
            <span
              className="inline-flex h-11 w-11 flex-shrink-0 items-center justify-center rounded-xl"
              style={{ backgroundColor: "rgba(15,174,150,0.14)", color: "#0FAE96" }}
            >
              <LucideIcon name={p.icon} className="h-5 w-5" />
            </span>
            <div>
              <h3 className="font-display text-base font-semibold tracking-tight text-foreground">{p.title}</h3>
              <p className="mt-1.5 font-body text-sm leading-relaxed text-muted-foreground">{p.body}</p>
            </div>
          </motion.div>
        ))}
      </div>
    </Section>
  );
}
